var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"General","count":_vm.count}},[_c('core-filter-input-daterange',{attrs:{"filter":_vm.value('date')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }